// External Dependencies
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';

// Internal Dependencies
import { BackToButton } from 'components/shared';
import { tableQueryParams } from 'state/table/selectors';
import { useGetInvoice } from 'hooks/api/invoices';

// Local Dependencies
import InvoiceInfoContent from './InvoiceInfoContent';

// Component Definition
const InvoiceShow = (): JSX.Element | null => {
  const { id } = useParams();

  const invoicesParams = useSelector(tableQueryParams('invoices'));

  const { data } = useGetInvoice(id as string);

  if (!data) {
    return null;
  }

  return (
    <>
      <Box marginBottom={3}>
        <BackToButton
          context="All Invoices"
          navigateTo={`/invoices${invoicesParams}`}
        />
      </Box>

      <InvoiceInfoContent data={data.data} />
    </>
  );
};

export default InvoiceShow;
